angular.module('app').controller('yearLegalController',
  ['$scope', function (scope) {

  }]);
